/**
 * Extracts venue name from address data
 * @param to_address - The address object containing raw and formatted fields, or a string address
 * @returns The venue name if found, otherwise falls back to formatted address
 */
export const getVenueName = (to_address: any): string => {
  if (!to_address) {
    return 'Destination';
  }

  // Handle string input (treat as raw address)
  if (typeof to_address === 'string') {
    const firstPart = to_address.split(',')[0].trim();
    
    // If the first part looks like a venue name (not just numbers or generic address)
    // and is not too short, use it as the venue name
    if (firstPart && firstPart.length > 3 && !firstPart.match(/^\d+$/)) {
      return firstPart;
    }
    
    return to_address;
  }

  // Check if raw field exists and contains venue information
  if (to_address.raw && typeof to_address.raw === 'string') {
    // Extract the first part before the first comma, which is typically the venue name
    const firstPart = to_address.raw.split(',')[0].trim();
    
    // If the first part looks like a venue name (not just numbers or generic address)
    // and is not too short, use it as the venue name
    if (firstPart && firstPart.length > 3 && !firstPart.match(/^\d+$/)) {
      return firstPart;
    }
  }

  // Fall back to formatted address or raw address
  return to_address.formatted || to_address.raw || 'Destination';
};